import { IntlShape } from 'react-intl';
import { SELECT } from 'common/constants';
import { messages as cashCompanyMessages } from 'components/CashCompanyDropdown/messages';
import { messages as disbursementJournalMessages } from 'components/DisbursementsJournalDropdown/messages';
import { DropdownValue } from 'components/Dropdown/types';
import { CashCompanies, Journals } from './types';

export const getCashCompanyLabel = (
  companyId: string,
  storeName: string
): string => `${companyId} - ${storeName}`;

export const getJournalLabel = (
  journalNumber: string,
  journalName: string,
  companyId: string
): string => `${journalNumber} - ${journalName} (${companyId})`;

export const createCashCompanyDropdown = (
  cashCompanies: CashCompanies[] | undefined
): DropdownValue[] | undefined =>
  cashCompanies?.map(cashCompany => {
    const { companyId, storeName } = cashCompany;
    return {
      label: getCashCompanyLabel(companyId, storeName),
      value: companyId
    };
  });

export const findDefaultCashAccountOption = (
  storeId: string,
  cashCompanies: CashCompanies[] | undefined,
  intl: IntlShape
): DropdownValue => {
  if (cashCompanies && cashCompanies.length > 0) {
    const defaultCompany = cashCompanies?.find(
      cashComp => cashComp.storeId === storeId
    );
    if (defaultCompany) {
      const { companyId, storeName } = defaultCompany;
      return {
        label: getCashCompanyLabel(companyId, storeName),
        value: companyId
      };
    }
    const { companyId, storeName } = cashCompanies?.[0];
    return {
      label: getCashCompanyLabel(companyId, storeName),
      value: companyId
    };
  }
  return {
    label: intl.formatMessage(cashCompanyMessages.cashCompanyDefaultVal),
    value: SELECT
  };
};

export const createJournalDropdown = (
  disbursementJournals: Journals[] | undefined
): DropdownValue[] | undefined =>
  disbursementJournals?.map(journal => {
    const { companyId, journalName, journalNumber } = journal;
    return {
      label: getJournalLabel(journalNumber, journalName, companyId),
      value: JSON.stringify(journal)
    };
  });

export const findDefaultJournalOption = (
  cashCompanyId: string,
  disbursementJournals: Journals[] | undefined,
  intl: IntlShape
): DropdownValue => {
  if (disbursementJournals && disbursementJournals.length > 0) {
    const defaultJournal =
      disbursementJournals?.find(
        journal => journal.companyId === cashCompanyId
      ) ?? disbursementJournals[0];
    return {
      label: getJournalLabel(
        defaultJournal.journalNumber,
        defaultJournal.journalName,
        defaultJournal.companyId
      ),
      value: JSON.stringify(defaultJournal)
    };
  }
  return {
    label: intl.formatMessage(
      disbursementJournalMessages.disbursementJournalDefaultVal
    ),
    value: SELECT
  };
};

export const getStoreIdByCompanyId = (
  storeData: CashCompanies[] | undefined,
  companyId: string | undefined
): string => {
  const store =
    storeData && storeData.find(data => data.companyId === companyId);
  return store ? store.storeId : '';
};
